import {getClientConfig} from 'ultra/configs/general';
import {get} from '../../../Helpers/http';

const {api} = getClientConfig(window)

export function getContentShopsConfig() {
    return get(`${api}/partner/configs/shops`);
}
